import axios from '@/allotment/axios'

export default {
  save: data => axios.post('/device/param/save', data), //保存参数表
  delete: id => axios.post('/device/param/update/status', { id, status: 1 }), //删除参数表
  page: data => axios.post('/device/param/select/page', data), //获取参数表分页
  detailSave: data => axios.post('/param/detail/save', data), //保存参数表版本
  detailDelete: id => axios.post('/param/detail/update/status', { id, status: 1 }), //删除参数表版本
  detailList: id => axios.get(`/param/detail/${id}`), //获取参数版本列表
  tree: () => axios.get('/device/param/tree'), //获取参数树形结构
  firmwareSave: data => axios.post('/firmware/save', data), //保存固件
  firmwarePage: data => axios.post('/firmware/select/page', data), //查询固件
  firmwareDelete: id => axios.get(`/firmware/delete/${id}`), //删除固件
  firmwareDetailSave: data => axios.post('/firmware/detail/save', data), //保存固件详情
  firmwareDetailList: data => axios.post('/firmware/detail/find/list', data), //查询固件详情
  firmwareDetailDelete: id => axios.get(`/firmware/detail/delete/${id}`), //删除固件详情
  upgradeSave: data => axios.post('/device/upgrade/save', data, { timeout: 10 * 60000 }), //保存升级详情
  upgradePage: data => axios.post('/device/upgrade/select/page', data), //查询升级详情
  upgradeTree: () => axios.get('/device/upgrade/source/tree') //树形升级详情
}
